import { StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import Layout from '../components/Layout/Layout'
import styles from '../style/photoalbum.module.css'

export default function photoalbum() {
    return (
        <Layout>
            <div className={styles.container}>
                <div className={styles.layout}>
                    <div className={styles.wrapper}> 
                            <h1 className="title"><span className="underline">Зургийн цомог</span></h1>
                            <div className={styles.grid}>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/1.jpg" alt="1" style={{maxWidth: '450px'}}/>
                                    <p>ЭЗХЗ-оос аудиторын батламж авлаа. 2017 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/2.jpg" alt="2" style={{maxWidth: '450px'}}/>
                                    <p>ЭХЗХ-оос сургагч багшийн батламж авлаа. 2016 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/3.jpg" alt="3" style={{maxWidth: '450px'}}/>
                                    <p>НҮБ-ын санхүүжилтээр хэрэгжсэн “Барилгын салбарт хүлэмжийн хийн ялгарлыг бууруулах  төсөл. ОУ-ын экспертүүдийн хамт. 2018 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/4.jpg" alt="4" style={{maxWidth: '450px'}}/>
                                    <p>ЭХЗХ-ны 25 жилийн ойн арга хэмжээ. Эрчим хүчний хэмнэлтийн чиглэлээр шилдэг өгүүлэл бичсэн ЭХЭЗХ-ийн судлаачид. 2015 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/5.jpg" alt="5" style={{maxWidth: '450px'}}/>
                                    <p>ТЕСО ХХК-н Милко үйлдвэр. 2017 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/10.jpg" alt="10" style={{maxWidth: '450px'}}/>
                                    <p>GGGI ОУБ-ын санхүүжилттэй хэрэгжсэн “Эрчим хүчний жишиг аудит” төсөл. PWC ОУБ-ын экспертүүдийг дагаж Витафит үйлдвэрт эрчим хүчний жишиг аудит хийлээ. 2017 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/7.jpg" alt="7" style={{maxWidth: '450px'}}/>
                                    <p>Эрдэнэт Баяжуулах үйлдвэрийн дулаан агааржуулалтын системийн аудит. 2019-2020 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/12.jpg" alt="12" style={{maxWidth: '450px'}}/>
                                    <p>“Эрчим хүчний хэмнэлт ба үр ашиг” семинар зохион байгуулах Обсерв ЗҮБ-ын ажлын хэсэг. 2019 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/8.jpg" alt="8" style={{maxWidth: '450px'}}/>
                                    <p>Таван толгойн, Зүүн цанхийн уурхайд хийсэн аудит. 2020 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/9.jpg" alt="9" style={{maxWidth: '450px'}}/>
                                    <p>Мөнхийн баян гал Цементийн үйлдвэрт хийсэн  аудит. 2019 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/6.jpg" alt="6" style={{maxWidth: '450px'}}/>
                                    <p>Эрчим сүлжээ ХХК. Ашиглалт, шуурхай ажиллагааны сургалт. 2013 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/11.jpg" alt="11" style={{maxWidth: '450px'}}/>
                                    <p>ISO 50001:2018 стандарт суртачлах мэдлэг хуваалцах уулзалт. 2019 он</p>
                                </div>
                                <div className={styles.photo}>
                                    <StaticImage src="../images/album/умжб.png" alt="11" style={{maxWidth: '450px'}}/>
                                    <p>ЕСБХБ-ны дэмжлэгтэйгээр хэрэгжүүлсэн Хангай дээд сургуулийн Эрчим хүчний аудит. 2021 он</p>
                                </div>

                            </div>
                    </div>
                </div>
            </div>
        </Layout>
    )
}
